import { useParams, useResolvedPath } from 'react-router-dom'

export const useRequiredParams = <T extends Record<string, string>>() => useParams() as T

export const useCurrentPath = () => useResolvedPath('').pathname
